import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { httpOptions } from '@portal-workspace/grow-ui-library';
import { PayloadApiResponse, FeatureFlag, UpdateFeatureFlagBody, UpdateFeatureFlagUserAccessBody } from '@portal-workspace/grow-shared-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const URL_GET_FEATURE_FLAGS = () => `${environment.api2Host}/api2/admin/feature-flags`;
const URL_UPDATE_FEATURE_FLAG = () => `${environment.api2Host}/api2/admin/feature-flags`;
const URL_UPDATE_FEATURE_FLAG_USER_ACCESS = () => `${environment.api2Host}/api2/admin/feature-flags/user-access`;

@Injectable()
export class FeatureFlagService {

  constructor(private httpClient: HttpClient) {}

  /**
   * Get all feature flags
   */
  getAllFeatureFlags(): Observable<FeatureFlag[]> {
    return this.httpClient.get<PayloadApiResponse<FeatureFlag[]>>(URL_GET_FEATURE_FLAGS(), httpOptions())
      .pipe(map((res: PayloadApiResponse<FeatureFlag[]>) => res.payload));
  }

  /**
   * Update a feature flag
   */
  updateFeatureFlag(body: UpdateFeatureFlagBody): Observable<FeatureFlag> {
    return this.httpClient.post<PayloadApiResponse<FeatureFlag>>(URL_UPDATE_FEATURE_FLAG(), body, httpOptions())
      .pipe(map((res: PayloadApiResponse<FeatureFlag>) => res.payload));
  }

  /**
   * Update user access for a feature flag
   */
  updateFeatureFlagUserAccess(body: UpdateFeatureFlagUserAccessBody): Observable<FeatureFlag> {
    return this.httpClient.post<PayloadApiResponse<FeatureFlag>>(URL_UPDATE_FEATURE_FLAG_USER_ACCESS(), body, httpOptions())
      .pipe(map((res: PayloadApiResponse<FeatureFlag>) => res.payload));
  }
}

